export const SheetSyncEvents = {
    MAIN_MAP_CHANGED_EVENT: 'mapChanged',
    CHANGING_SHEET_EVENT: 'changingSheet',
    SHEET_VISIBILITY_CHANGED_EVENT: 'sheetVisibilityChanged'
};

export const SHEET_OPACITY = 0.8; // When sheet is displayed on top of top view screenshot, it should be half transparent.
export const FADE_DURATION = 0.7; // Time to fade sheet's opacity. Value matches "transition: opacity 0.7s" inside Avatar.scss
export const ROTATION_DURATION = 2.0; // Time to rotate a sheet in order for it to face upwards.
export const WAIT_BEFORE_ROTATION = 1.0; // Time to rotate a sheet in order for it to face upwards.
